/** Troca obrigatória no primeiro acesso (RN-28). */
import { useState } from 'react'
import { PasswordInput } from './PasswordInput'
import { PalavrasLogo } from '@/components/PalavrasLogo'
import { isPalavras } from '@/services/palavrasBrand'

import { problemDetail } from '@/services/api'
import { changePassword, login } from '@/services/authService'

interface ChangePasswordViewProps {
  matricula: string
  schoolId: string
  tenantSlug: string
  onDone: () => void
}

export function ChangePasswordView({
  matricula,
  schoolId,
  tenantSlug,
  onDone,
}: ChangePasswordViewProps) {
  const [atual, setAtual] = useState('')
  const [nova, setNova] = useState('')
  const [confirmation, setConfirmation] = useState('')
  const [saving, setSaving] = useState(false)
  const [erro, setErro] = useState<string | null>(null)

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault()
    setErro(null)
    if (nova !== confirmation) {
      setErro('As senhas precisam ser iguais.')
      return
    }
    setSaving(true)
    try {
      await changePassword(atual, nova)
      // A troca revoga TODAS as sessões (RN-16): é preciso logar de novo.
      await login({ matricula, password: nova, school_id: schoolId, tenant_slug: tenantSlug })
      onDone()
    } catch (error) {
      setErro(problemDetail(error) ?? 'Não foi possível trocar a senha.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <form className="change-password" onSubmit={(e) => void handleSubmit(e)}>
      {isPalavras(tenantSlug) && <PalavrasLogo />}
      <h1>Crie sua senha</h1>
      <p>Por segurança, o primeiro acesso exige uma senha nova.</p>

      <label htmlFor="atual">Senha temporária</label>
      <PasswordInput id="atual" autoComplete="current-password" value={atual} onChange={(e) => setAtual(e.target.value)} required />

      <label htmlFor="nova">Nova senha (mínimo 8 caracteres)</label>
      <PasswordInput
        id="nova"
        minLength={8}
        maxLength={72}
        autoComplete="new-password"
        value={nova}
        onChange={(e) => setNova(e.target.value)}
        required
      />

      <label htmlFor="confirmacao">Repita a nova senha</label>
      <PasswordInput id="confirmacao" autoComplete="new-password" maxLength={72} value={confirmation} onChange={(e) => setConfirmation(e.target.value)} required />
      <ul className="password-checklist" aria-live="polite">
        <li>{nova.length >= 8 ? '✓' : '○'} Pelo menos 8 caracteres</li>
        <li>{nova && nova === confirmation ? '✓' : '○'} As duas senhas são iguais</li>
      </ul>
      {erro && <p role="alert" className="login-error">{erro}</p>}
      <button type="submit" disabled={saving || nova.length < 8 || nova !== confirmation}>{saving ? 'Salvando…' : 'Salvar e continuar'}</button>
    </form>
  )
}
